<template>
  <div :class="[{ 'pagination--center': !showPerPage }, 'pagination']">
    <template v-if="showPerPage">
      <div class="pagination-perpage">
        {{ rowsPerPageLabel }}
        <select
          id="perpage-select-pagination"
          :value="perPage"
          @input="emitPerPage"
        >
          <option
            v-for="value in perPageDropdown"
            :id="value + '-per-page-select'"
            :key="value"
            :value="value"
          >
            {{ value }}
          </option>
        </select>
      </div>
    </template>
    <loader
      v-show="loading"
      :size="35"
    />
    <div class="pagination-section">
      <div
        v-if="rowLabel"
        class="pagination-info_box"
      >
        {{ totalRows }} {{ rowLabel }}
      </div>
      <div class="pagination-controls">
        <button
          id="previous-pagination"
          class="pagination-button"
          :disabled="!canPrevious"
          @click="emitPreviousPage"
          v-html="previousIcon"
        />
        Page
        <input
          id="page-number-pagination"
          type="text"
          :value="page"
          @keyup.enter="emitToPage"
        />
        of {{ totalPages }}
        <button
          id="next-pagination"
          class="pagination-button"
          :disabled="!canNext"
          @click="emitNextPage"
          v-html="nextIcon"
        />
      </div>
    </div>
  </div>
</template>

<script>
import feather from 'feather-icons'
import Loader from '@/components/loader.vue'

export default {
  name: 'Pagination',
  components: {
    Loader,
  },
  props: {
    page: {
      type: Number,
      required: true,
    },
    perPage: {
      type: Number,
      required: true,
    },
    totalRows: {
      type: Number,
      required: true,
    },
    rowLabel: {
      type: String,
      default: '',
    },
    rowsPerPageLabel: {
      type: String,
      default: 'Rows per page',
    },
    showPerPage: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      perPageDropdown: [10, 25, 50, 100],
      nextIcon: feather.icons['chevron-right'].toSvg(),
      previousIcon: feather.icons['chevron-left'].toSvg(),
    }
  },
  computed: {
    totalPages() {
      const _totalPages = Math.ceil(this.totalRows / this.perPage)
      return _totalPages > 0 ? _totalPages : 1
    },
    canNext() {
      return this.page < this.totalPages
    },
    canPrevious() {
      return this.page > 1
    },
  },
  methods: {
    emitPreviousPage() {
      if (this.canPrevious) {
        const _page = this.page - 1
        this.$emit('update:page', _page)
      }
    },
    emitNextPage() {
      if (this.canNext) {
        const _page = this.page + 1
        this.$emit('update:page', _page)
      }
    },
    emitPerPage(event) {
      const _perPageNumber = Number.parseInt(event.target.value)
      this.$emit('update:perPage', _perPageNumber)
      this.$emit('update:page', 1)
    },
    emitToPage(event) {
      const _pageNumber = Number.parseInt(event.target.value)
      if (_pageNumber <= this.totalPages && _pageNumber > 0) {
        this.$emit('update:page', _pageNumber)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.pagination {
  width: 100%;
  margin-top: 2em;
  @include flex-display();
  @include flex-justify-content(space-between);
  @include flex-align-items(center);
  &--center {
    @include flex-justify-content(center);
  }
  &-section {
    @include flex-display();
    @include flex-align-items(center);
    @include flex-justify-content(space-between);
  }
  &-controls {
    @include flex-display();
    @include flex-align-items(center);
    font-size: $small-font;
    color: $black;
    input {
      font-size: $default-font;
      padding: 0.5em;
      border-radius: 5px;
      border: 1px solid $light-grey;
      margin: 0 1em;
      width: 30px;
    }
  }
  &-perpage {
    color: $black;
    font-size: $small-font;
    font-style: italic;
    select {
      margin-left: 0.5em;
      border-radius: 5px;
      padding: 0.5em;
      border: none;
      background: transparent;
      border: 1px solid $light-grey;
      font-size: $default-font;
    }
  }
  &-info_box {
    background-color: $off-white;
    border-radius: 10px;
    font-weight: bold;
    padding: 5px 10px;
    display: inline-block;
    color: $dark-grey;
    font-size: $small-font;
  }
  &-button {
    @include flex-display();
    @include flex-justify-content(center);
    @include flex-align-items(center);
    background: transparent;
    border: none;
    padding: 0.5em;
    border-radius: 5px;
    &#previous-pagination {
      margin-right: 1em;
    }
    &#next-pagination {
      margin-left: 1em;
    }
    &:disabled {
      cursor: not-allowed;
      color: $light-grey;
    }
    &:hover {
      cursor: pointer;
      background: $off-white;
      border-radius: 50%;
      &:disabled {
        cursor: not-allowed;
        color: $light-grey;
        background: transparent;
      }
    }
  }
}
</style>
